import { useTranslation } from 'react-i18next'

import styles from './ChatPinTitle.module.scss'

export const ChatPinTitle = () => {
  const { t } = useTranslation()

  return <h3 className={styles.root}>{t('chat.pinnedMessages.title')}</h3>
}
